import { cn } from '@/lib/utils'

/** Approved vector lockup extracted from the St. George 2026 identity manual. */
export function BrandLogo({
  className,
  inverse = false,
}: {
  className?: string
  inverse?: boolean
}) {
  return (
    <span className={cn('inline-flex w-48 shrink-0', className)}>
      <img
        src={inverse ? '/brand/logo-white.svg' : '/brand/logo.svg'}
        alt="St. George · English School"
        width={249}
        height={49}
        className={cn('h-auto w-full', !inverse && 'dark:hidden')}
      />
      {!inverse && (
        <img
          src="/brand/logo-white.svg"
          alt="St. George · English School"
          width={222}
          height={43}
          className="hidden h-auto w-full dark:block"
        />
      )}
    </span>
  )
}
